import { render } from "./SuccessView.vue?vue&type=template&id=6b01e398&scoped=true"
import script from "./SuccessView.vue?vue&type=script&lang=js"
export * from "./SuccessView.vue?vue&type=script&lang=js"

import "./SuccessView.vue?vue&type=style&index=0&id=6b01e398&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/freefi_meal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b01e398"]])

export default __exports__